import { queryState, createState, updateState } from "./creator";

export const queriedLabourAccounts = queryState.selector;

export const createLabourAccountObj = createState.selector;

export const updateLabourAccountObj = updateState.selector;
